import { Box, Grid2, Paper, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import { CampaignTable } from '../../common/campaign/CampaignTable'
import CommonPageWrapper from '../../common/components/CommonPageWrapper'
import Loader from '../../common/loader/Loader'
import { Campaign } from '../../common/types/campaigns'
import { Query } from '../../react-apollo/Components'
import { i18n } from '../index'
import stationStore from '../station/stationStore'
import { campaignPageQuery } from './campaignPageQueries'

const CampaignPage = observer(() => {
  const stationId = stationStore.activeStationId
  const now = moment()
  return (
    <CommonPageWrapper title={i18n.t('campaigns.heading')}>
      {(stationId && (
        <Query<{ campaigns: Campaign[] }, { stationId: string }>
          query={campaignPageQuery}
          skip={!stationId}
          variables={{
            stationId,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => {
            const campaigns = (data?.campaigns ?? []) as Campaign[]
            const currentCampaigns = campaigns.filter(
              (campaign: Campaign) =>
                moment(campaign.startTime).isSameOrBefore(now) && moment(campaign.endTime).isSameOrAfter(now),
            )
            const futureCampaigns = campaigns.filter((campaign: Campaign) => moment(campaign.startTime).isAfter(now))
            return (
              <Loader loading={loading} error={error}>
                <Grid2 container spacing={2} direction='column'>
                  <Grid2>
                    <Typography variant='h5'>{i18n.t('campaigns.heading')}</Typography>
                  </Grid2>
                  <Grid2>
                    <Typography variant='h6'>{i18n.t('campaigns.currentCampaigns')}</Typography>
                    <Box>
                      <Paper>
                        <CampaignTable campaigns={currentCampaigns} />
                      </Paper>
                    </Box>
                  </Grid2>
                  <Grid2>
                    <Typography variant='h6'>{i18n.t('campaigns.futureCampaigns')}</Typography>
                    <Box>
                      <Paper>
                        <CampaignTable campaigns={futureCampaigns} />
                      </Paper>
                    </Box>
                  </Grid2>
                </Grid2>
              </Loader>
            )
          }}
        </Query>
      )) || <Typography>{i18n.t('common.errorNoStationId')}</Typography>}
    </CommonPageWrapper>
  )
})

export default CampaignPage
